import { createApi } from "@reduxjs/toolkit/query/react"
import { retry } from "@reduxjs/toolkit/query"
// import { login } from "./userReducer"
import { OldBaseQueryWithReAuth } from "../configuration/authInterceptor";
import { BaseQueryWithReAuth, OrdersBaseQueryWithReAuth } from "../configuration/authInterceptor";

const retryTransientFailures = {
    retryCondition: (error: { status?: number | string }, _args: unknown, {attempt}: {attempt: number}) =>
        attempt <= 2 && (
            (typeof error.status === "number" && error.status >= 500) ||
            error.status === "FETCH_ERROR" ||
            error.status === "TIMEOUT_ERROR"
        )
};

export const oldServerApi = createApi({
    reducerPath: "articles",
    baseQuery: retry(OldBaseQueryWithReAuth, retryTransientFailures),
    endpoints: (builder) => ({
        authenticate: builder.mutation({
            query(data) {
                return {
                    url: "/account/authenticate",
                    method: "POST",
                    body: data
                }
            }
        })
    })
})

export const serverApi = createApi({
    reducerPath: "articlesNew",
    baseQuery: retry(BaseQueryWithReAuth, retryTransientFailures),
    tagTypes: ['Orders'],
    endpoints: (builder) => ({
        authenticate: builder.mutation({
            query(data) {
                return {
                    url: "/account/authenticate",
                    method: "POST",
                    body: data
                }
            }
        })
    })
})

export const ordersApi = createApi({
    reducerPath: "orders",
    baseQuery: retry(OrdersBaseQueryWithReAuth, retryTransientFailures),
    tagTypes: ['Orders'],
    endpoints: (builder) => ({})
})

export const { useAuthenticateMutation } = oldServerApi
export const { useAuthenticateMutation: useNewAuthenticateMutation } = serverApi
